import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from "./store/index"
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/common.css'

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
Vue.prototype.$store = store

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
new Vue({
  render: h => h(App),
  store,
  router,
}).$mount('#app')
